// Styles du mode formulaire — design CLAIR & BOLD (crème + orange).
// Scopés dans le Shadow DOM.

export const FORM_STYLES = `
:host {
  --ef-bg: #fdf7f1;            /* crème chaud */
  --ef-panel: #ffffff;
  --ef-panel-2: #f6ede4;
  --ef-orange: #e8842c;        /* accent principal */
  --ef-rust: #b0421a;          /* rust foncé */
  --ef-soft: rgba(232,132,44,0.12);
  --ef-text: #2a1d14;
  --ef-muted: #8a7d72;
  --ef-border: #ece2d8;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  color: var(--ef-text);
  display: block;
  height: 100%;
}
* { box-sizing: border-box; }

.ef-root {
  width: 100%;
  min-height: 100%;
  background: var(--ef-bg);
  background-image: radial-gradient(circle at 85% -10%, rgba(232,132,44,0.10), transparent 42%);
  padding: 32px 28px 48px;
}
.ef-step, .ef-result { width: 100%; max-width: 860px; margin: 0 auto; }

/* Progression ------------------------------------------- */
.ef-progress { display: flex; gap: 6px; margin-bottom: 20px; }
.ef-seg { flex: 1; height: 4px; background: var(--ef-border); border-radius: 4px; transition: background .3s ease; }
.ef-seg.on { background: var(--ef-orange); }

.ef-kicker {
  font-size: 12px; color: var(--ef-rust); letter-spacing: .2em;
  text-transform: uppercase; font-weight: 700; margin-bottom: 8px;
}
.ef-title {
  font-size: 30px; font-weight: 800; letter-spacing: -0.01em; line-height: 1.06;
  margin: 0 0 6px 0; text-transform: uppercase; color: var(--ef-text);
}
.ef-next { font-size: 13px; color: var(--ef-muted); margin-bottom: 18px; letter-spacing: .02em; }
.ef-prompt { font-size: 18px; color: var(--ef-text); margin: 14px 0 20px; font-weight: 500; }
.ef-hint { color: var(--ef-muted); font-weight: 400; font-size: 15px; }

/* Cartes ------------------------------------------------- */
.ef-cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); gap: 14px; }
.ef-card {
  display: flex; flex-direction: column;
  background: var(--ef-panel);
  border: 1.5px solid var(--ef-border);
  border-radius: 14px; padding: 0; overflow: hidden;
  cursor: pointer; text-align: left; color: var(--ef-text);
  transition: border-color .15s ease, transform .12s ease, box-shadow .15s ease, background .15s ease;
}
.ef-card:hover {
  border-color: var(--ef-orange); transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(176,66,26,0.12);
}
.ef-card.sel {
  border-color: var(--ef-orange); background: var(--ef-soft);
  box-shadow: 0 0 0 2px var(--ef-orange) inset;
}
.ef-card-illus {
  background: linear-gradient(180deg, #fffaf4, #f6ede4);
  display: flex; justify-content: center; align-items: center; padding: 14px;
}
.ef-card-illus .eteka-silhouette { width: auto; height: 200px; display: block; }
.ef-card-img { width: 100%; height: 200px; object-fit: cover; }
.ef-card-text { padding: 14px 16px 18px; }
.ef-card-title {
  font-size: 14px; font-weight: 800; letter-spacing: .06em;
  text-transform: uppercase; margin-bottom: 5px;
}
.ef-card-desc { font-size: 13px; color: var(--ef-muted); line-height: 1.5; }

/* Saisie numérique (mesures) ----------------------------- */
.ef-measure { display: flex; align-items: center; gap: 12px; max-width: 360px; }
.ef-measure input {
  flex: 1; border: 1.5px solid var(--ef-border); border-radius: 12px;
  padding: 14px 16px; font-size: 20px; font-weight: 600; font-family: inherit;
  color: var(--ef-text); background: var(--ef-panel); outline: none;
  transition: border-color .15s ease;
}
.ef-measure input:focus { border-color: var(--ef-orange); }
.ef-measure-unit { font-size: 16px; color: var(--ef-muted); font-weight: 600; }
.ef-input-error { border-color: #d6453a !important; }

/* Bouton continuer/valider ------------------------------- */
.ef-continue {
  margin-top: 26px; background: var(--ef-orange); color: #fff; border: none;
  padding: 15px 36px; border-radius: 12px; font-size: 15px; font-weight: 700;
  letter-spacing: .04em; text-transform: uppercase; cursor: pointer;
  transition: transform .12s ease, box-shadow .15s ease, filter .15s ease;
}
.ef-continue:disabled { background: #e3d7ca; color: #a89a8c; cursor: not-allowed; }
.ef-continue:not(:disabled):hover { transform: translateY(-2px); box-shadow: 0 10px 22px rgba(232,132,44,0.35); }

/* Résultat ---------------------------------------------- */
.ef-result-head {
  display: flex; gap: 22px; align-items: center;
  border-bottom: 1px solid var(--ef-border); padding-bottom: 18px; margin-bottom: 18px;
}
.ef-result-illus { flex-shrink: 0; background: linear-gradient(180deg,#fffaf4,#f6ede4); border-radius: 14px; padding: 10px; }
.ef-result-illus .eteka-silhouette { height: 130px; width: auto; }
.ef-reco-title { font-size: 15px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; margin: 0 0 12px; }
.ef-reco { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 14px; }
.ef-product {
  display: flex; gap: 14px; align-items: center;
  border: 1.5px solid var(--ef-border); background: var(--ef-panel);
  border-radius: 14px; padding: 14px; transition: border-color .15s ease, box-shadow .15s ease;
}
.ef-product:hover { border-color: var(--ef-orange); box-shadow: 0 8px 20px rgba(176,66,26,0.1); }
.ef-product-img { width: 76px; height: 76px; border-radius: 10px; object-fit: cover; flex-shrink: 0; background: var(--ef-panel-2); }
.ef-product-ph { display: flex; align-items: center; justify-content: center; font-size: 30px; font-weight: 800; color: var(--ef-orange); }
.ef-product-body { min-width: 0; }
.ef-product-name { font-weight: 700; font-size: 15px; letter-spacing: .02em; }
.ef-product-reason { font-size: 12.5px; color: var(--ef-muted); line-height: 1.45; margin-top: 3px; }
.ef-product-meta { display: flex; gap: 8px; align-items: center; margin-top: 8px; flex-wrap: wrap; }
.ef-badge-ok { font-size: 11px; color: #1f7a44; background: rgba(31,122,68,0.1); padding: 3px 9px; border-radius: 999px; font-weight: 600; }
.ef-badge-ko { font-size: 11px; color: #c0392b; background: rgba(192,57,43,0.1); padding: 3px 9px; border-radius: 999px; font-weight: 600; }
.ef-product-link { font-size: 13px; font-weight: 700; color: var(--ef-rust); text-decoration: none; letter-spacing: .02em; }
.ef-product-link:hover { text-decoration: underline; }
.ef-restart {
  margin-top: 18px; background: none; border: 1.5px solid var(--ef-border);
  padding: 10px 22px; border-radius: 12px; cursor: pointer; color: var(--ef-muted);
  font-weight: 700; letter-spacing: .04em; text-transform: uppercase; font-size: 12px;
}
.ef-restart:hover { border-color: var(--ef-orange); color: var(--ef-text); }

/* Profil récap (résultat) -------------------------------- */
.ef-profile-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;
  margin-bottom: 16px;
}
.ef-prof {
  background: var(--ef-panel); border: 1px solid var(--ef-border);
  border-radius: 10px; padding: 10px 12px;
}
.ef-prof-l { font-size: 10px; letter-spacing: .12em; text-transform: uppercase; color: var(--ef-muted); margin-bottom: 3px; }
.ef-prof-v { font-size: 15px; font-weight: 700; color: var(--ef-text); }

/* Blocs (scores, tips) ----------------------------------- */
.ef-block {
  background: var(--ef-panel); border: 1px solid var(--ef-border);
  border-radius: 12px; padding: 14px 16px; margin-bottom: 14px;
}
.ef-block-title {
  font-size: 11px; letter-spacing: .15em; text-transform: uppercase;
  color: var(--ef-muted); margin-bottom: 12px; font-weight: 700;
}
.ef-scores { display: flex; flex-direction: column; gap: 8px; }
.ef-score-row { display: flex; align-items: center; gap: 10px; }
.ef-s-letter { font-weight: 800; font-size: 14px; width: 16px; color: var(--ef-text); }
.ef-s-track { flex: 1; height: 4px; background: var(--ef-border); border-radius: 4px; overflow: hidden; }
.ef-s-fill { height: 100%; background: var(--ef-orange); transition: width .8s ease; }
.ef-s-pct { font-size: 11px; color: var(--ef-muted); width: 36px; text-align: right; }

.ef-tips-block { border-left: 3px solid var(--ef-orange); background: var(--ef-soft); }
.ef-tips { list-style: none; padding: 0; margin: 0; }
.ef-tips li {
  font-size: 13px; line-height: 1.5; padding: 3px 0 3px 14px; position: relative; color: var(--ef-text);
}
.ef-tips li::before { content: '—'; position: absolute; left: 0; color: var(--ef-orange); }

/* Reco riche --------------------------------------------- */
.ef-reco-section { margin-bottom: 14px; }
.ef-reco-title { font-size: 18px; font-weight: 800; letter-spacing: -.01em; margin: 0 0 4px; color: var(--ef-text); }
.ef-reco-sub { font-size: 12px; color: var(--ef-muted); margin-bottom: 12px; }
.ef-reco-cat { font-size: 11px; letter-spacing: .12em; text-transform: uppercase; color: var(--ef-muted); margin: 12px 0 8px; font-weight: 700; }
.ef-reco-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 10px; }
.ef-reco-card { background: var(--ef-panel); border: 1px solid var(--ef-border); border-radius: 12px; overflow: hidden; transition: border-color .15s; }
.ef-reco-card:hover { border-color: var(--ef-orange); }
.ef-reco-img { height: 160px; padding: 12px; position: relative; display: flex; align-items: flex-end; transition: background 0.3s ease; }
/* Sur la vraie photo Wix, on cache le nom (la photo se suffit) et on garde juste le badge */
.ef-reco-img.ef-reco-img-real::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0) 50%, rgba(0,0,0,0.45) 100%);
  pointer-events: none;
}
.ef-reco-img.ef-reco-img-real .ef-reco-img-name { display: none; }
.ef-reco-img-name { color: #fff; font-weight: 700; font-size: 13px; line-height: 1.2; z-index: 1; position: relative; }
.ef-reco-img-name span { font-size: 11px; opacity: .8; font-weight: 400; }
.ef-match {
  position: absolute; top: 8px; right: 8px;
  font-size: 10px; font-weight: 700; padding: 3px 8px; border-radius: 4px; color: #fff;
}
.ef-match-high { background: #2D6A4F; }
.ef-match-medium { background: var(--ef-rust); }
.ef-reco-body { padding: 10px 12px; }
.ef-reco-ref { font-size: 10px; letter-spacing: .1em; text-transform: uppercase; color: var(--ef-muted); margin-bottom: 2px; }
.ef-reco-name { font-weight: 800; font-size: 14px; color: var(--ef-text); }
.ef-reco-type { font-size: 11px; color: var(--ef-muted); margin-bottom: 5px; }
.ef-reco-size { font-size: 12px; color: var(--ef-orange); font-weight: 700; margin-bottom: 3px; }
.ef-size-note { color: var(--ef-muted); font-weight: 400; font-size: 11px; }
.ef-reco-why { font-size: 11px; color: var(--ef-rust); line-height: 1.4; }
.ef-color-row { display: flex; gap: 4px; margin-top: 6px; }
.ef-swatch { width: 12px; height: 12px; border-radius: 50%; border: .5px solid rgba(0,0,0,.1); }

/* === Jauge de taille (nouvelle v3.1) === */
.ef-size-gauge { margin: 8px 0 4px; }
.ef-size-track {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 6px 0;
}
.ef-size-track::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 14px;
  right: 14px;
  height: 2px;
  background: var(--ef-border);
  transform: translateY(-50%);
}
.ef-size-tick {
  position: relative;
  z-index: 1;
  background: var(--ef-panel, #fff);
  padding: 4px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  color: var(--ef-muted);
  border: 1px solid var(--ef-border);
  letter-spacing: 0.02em;
}
.ef-size-tick.primary {
  background: var(--ef-orange);
  color: #fff;
  border-color: var(--ef-orange);
  font-size: 13px;
  padding: 5px 11px;
  box-shadow: 0 2px 8px rgba(232,132,44,0.35);
}
.ef-size-tick.alt {
  background: rgba(232,132,44,0.12);
  color: var(--ef-orange);
  border: 1px dashed var(--ef-orange);
}
.ef-size-hint {
  font-size: 12px;
  color: var(--ef-muted);
  text-align: center;
  margin-top: 6px;
  font-style: italic;
}
/* Grand format (mode product) */
.ef-size-gauge.large .ef-size-tick { font-size: 14px; padding: 6px 12px; }
.ef-size-gauge.large .ef-size-tick.primary { font-size: 18px; padding: 8px 16px; }
.ef-size-gauge.large .ef-size-hint { font-size: 13px; }
.ef-reco-card { text-decoration: none; color: inherit; cursor: pointer; }
.ef-reco-card:hover { border-color: var(--ef-orange); box-shadow: 0 4px 16px rgba(232,132,44,.18); }
.ef-reco-cta {
  margin-top: 10px; font-weight: 700; font-size: 13px; color: var(--ef-orange);
  text-transform: uppercase; letter-spacing: .04em;
}

/* Consent ------------------------------------------------ */
.ef-consent {
  background: var(--ef-panel); border: 1px solid var(--ef-border);
  border-radius: 12px; padding: 14px 16px; margin: 18px 0;
  display: flex; gap: 12px; align-items: flex-start; cursor: pointer;
  transition: border-color .15s;
}
.ef-consent.checked { border-color: var(--ef-orange); background: var(--ef-soft); }
.ef-consent-box {
  width: 18px; height: 18px; border: 1.5px solid var(--ef-muted);
  border-radius: 4px; flex-shrink: 0; margin-top: 2px;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.ef-consent.checked .ef-consent-box { background: var(--ef-orange); border-color: var(--ef-orange); }
.ef-consent.checked .ef-consent-box::after { content: '✓'; color: #fff; font-size: 12px; font-weight: 700; }
.ef-consent-text strong { font-size: 14px; color: var(--ef-text); display: block; margin-bottom: 4px; }
.ef-consent-text p { font-size: 12px; color: var(--ef-muted); line-height: 1.5; margin: 0; }

.ef-actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-top: 18px; }

/* Mobile ------------------------------------------------- */
@media (max-width: 600px) {
  .ef-root { padding: 24px 16px 48px; }
  .ef-title { font-size: 27px; }
  .ef-cards { grid-template-columns: repeat(2, 1fr); gap: 10px; }
  .ef-card-illus .eteka-silhouette { height: 150px; }
  .ef-card-img { height: 150px; }
  .ef-result-head { flex-direction: column; text-align: center; gap: 16px; }
}
`;
